import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { parksApi } from '@/api/index';

export const fetchParks = createAsyncThunk(
  'parks',
  async (params, thunkAPI) => {
    try {
      const response = await parksApi.getAll();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
